import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/ats-recruiter/src/component/Index.tsx");
